import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TipoSolicitudService {
  private apiUrl = `${environment.apiUrl}/sla`;

  constructor(private http: HttpClient) { }

  findAll() {
    return this.http.get<any[]>(this.apiUrl);
  }

  findAllPaginado(
    page: number,
    limit: number,
    sortBy: string,
    sortOrder: string,
    search: string,
    clienteId: number | null,
    exportData: boolean = false,
    tipoServicioId: number | null = null
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('sortBy', sortBy)
      .set('sortOrder', sortOrder)
      .set('exportData', exportData.toString());

    if (search) params = params.set('search', search);
    if (clienteId) params = params.set('clienteId', clienteId.toString());
    if (tipoServicioId) params = params.set('tipoServicioId', tipoServicioId.toString());

    return this.http.get<any>(`${this.apiUrl}/paginado`, { params });
  }

  restore(id: number) {
    return this.http.put<any>(`${this.apiUrl}/${id}/reactivar`, {});
  }

  findById(id: number) {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  create(data: any) {
    return this.http.post<any>(this.apiUrl, data);
  }

  update(id: number, data: any) {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data);
  }

  delete(id: number) {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }

  findAllClientes() {
    return this.http.get<any[]>(`${environment.apiUrl}/client`);
  }

  findAllTiposServicio() {
    return this.http.get<any[]>(`${environment.apiUrl}/tipo-servicio`);
  }

  findByClienteId(clienteId: number) {
    return this.http.get<any[]>(this.apiUrl).toPromise().then((response: any[] | undefined) => {
      return (response || []).filter((item: any) => item.cliente?.id === clienteId);
    });
  }
}
